import {
    DELETE_DISCOUNT,
    DELETE_DISCOUNT_FAILURE,
    DELETE_DISCOUNT_SUCCESS,
} from 'store/actions/types';

export const deleteDiscount = (payload) => {
    return {
        type: DELETE_DISCOUNT,
        payload: payload,
    };
};

export const deleteDiscountFailure = (error) => {
    return {
        type: DELETE_DISCOUNT_FAILURE,
        error: error,
    };
};

export const deleteDiscountSuccess = (payload) => {
    return {
        type: DELETE_DISCOUNT_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discounts/deleteDiscounts.js